module.exports = __webpack_public_path__ + "img/gobroadcast.2378d32d.svg";